import { createContext, use } from "react";

export interface AppShellBlockingAction {
  /** Optional visible and accessible description of the pending action. */
  label?: string;
}

export type AppShellContextValue = {
  /** Shows a viewport-wide blocking action and returns a function that dismisses it. */
  beginBlockingAction: (action: AppShellBlockingAction) => () => void;
  desktopSidebarCollapsed: boolean;
  isMobile: boolean;
  mobileNavigationOpen: boolean;
  setDesktopSidebarCollapsed: (collapsed: boolean) => void;
  setMobileNavigationOpen: (open: boolean) => void;
};

const AppShellContext = createContext<AppShellContextValue | null>(null);

function useAppShellContext() {
  return use(AppShellContext);
}

function useAppShell() {
  const appShell = use(AppShellContext);

  if (!appShell) {
    throw new Error("useAppShell must be used within AppShell.");
  }

  return appShell;
}

export { AppShellContext, useAppShell, useAppShellContext };
